import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const ButtonContianer = styled.button`
  border-radius: 4px;
  box-shadow: 0 0 3px 0 rgba(191, 191, 191, 0.5);
  background-color: ${COLORS.brandSecondary} !important;
  border: none;
  cursor: pointer;
`;

const Title = styled.div`
  padding: 10px 60px;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 23.5px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  text-transform: uppercase;
  color: ${COLORS.black};
`;
export function RoundButtons(props) {
  return (
    <ButtonContianer type={props.type} onClick={props.onClick}>
      <Title>{props.title}</Title>
    </ButtonContianer>
  );
}

RoundButtons.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.any
};
RoundButtons.defaultProps = {
  title: 'Countinue'
};
